export default __webpack_public_path__ + "media/images/li_dot-a31887cbceea6a4c5c5f083b52df950c.gif";